/**
 * QUISACO: interruptor de tema claro/oscuro (spec 003, FR-003-07).
 * El tema inicial lo aplica snippets/quisaco-theme-mode.liquid antes del primer pintado;
 * aquí solo se cambia y se guarda la elección del visitante.
 */
const KEY = 'quisaco-theme';
const root = document.documentElement;

function currentTheme() {
  return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

class QuisacoThemeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.onClick = () => {
      const next = currentTheme() === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      root.style.colorScheme = next;
      try {
        localStorage.setItem(KEY, next);
      } catch (error) {
        // Sin almacenamiento (modo privado): el cambio dura solo esta página.
      }
    };
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(root, { attributes: true, attributeFilter: ['data-theme'] });
    this.button.addEventListener('click', this.onClick);
    this.sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }

  sync() {
    this.button.setAttribute('aria-pressed', String(currentTheme() === 'dark'));
  }
}

if (!customElements.get('quisaco-theme-toggle')) {
  customElements.define('quisaco-theme-toggle', QuisacoThemeToggle);
}

/**
 * QUISACO: resalta el precio cuando cambia la presentación (FR-003-14). Horizon reemplaza el
 * contenedor [ref="priceContainer"] dentro de <product-price>; al llegar el nuevo se marca un momento.
 */
function watchPrice(productPrice) {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement) || node.getAttribute('ref') !== 'priceContainer') continue;
        node.classList.remove('q-price-changed');
        void node.offsetWidth; // reinicia la animación si se cambia de presentación rápido
        node.classList.add('q-price-changed');
        node.addEventListener('animationend', () => node.classList.remove('q-price-changed'), { once: true });
      }
    }
  }).observe(productPrice, { childList: true, subtree: true });
}

document.querySelectorAll('product-price').forEach(watchPrice);
